import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const SRC_COLOR  = {"Google Maps":"#4285f4","JustDial":"#e8441a","IndiaMart":"#ff6600","Sulekha":"#00a651"};
const intentStyle = {
  hot:  { bg:"#00d4aa18", color:"#00d4aa", border:"#00d4aa44" },
  warm: { bg:"#f59e0b18", color:"#f59e0b", border:"#f59e0b44" },
  cold: { bg:"#f8717118", color:"#f87171", border:"#f8717144" },
};
const scoreColor = s => s >= 75 ? "#00d4aa" : s >= 50 ? "#f59e0b" : "#f87171";

export default function Dashboard() {
  const [leads, setLeads]     = useState([]);
  const [meta, setMeta]       = useState({ plan:"free", total:0, locked:0 });
  const [user, setUser]       = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState("");
  const [filter, setFilter]   = useState("all");
  const [tab, setTab]         = useState("leads");
  const navigate = useNavigate();
  const email = localStorage.getItem("email") || "";

  useEffect(() => {
    Promise.all([
      API.get("/leads").catch(() => ({ data: { leads:[], plan:"free", total:0 } })),
      API.get("/auth/me").catch(() => ({ data: {} })),
      API.get("/schedule/status").catch(() => ({ data: {} })),
    ]).then(([leadsRes, meRes, schedRes]) => {
      const d = leadsRes.data;
      const me = meRes.data || {};
      const sc = schedRes.data || {};
      setLeads(d.leads || []);
      setMeta({ plan: d.plan||"free", total: d.total||0, locked: d.locked||0 });
      setUser({ ...me, lead_frequency: sc.interval_minutes || me.lead_frequency || 360, auto_enabled: sc.active || me.auto_enabled || false });
      setLoading(false);
    });
  }, []);

  const logout = () => { localStorage.clear(); window.location.href = "/"; };
  const isPremium = meta.plan !== "free";
  const searches  = user.searches || 0;
  const searchesLeft = Math.max(0, 2 - searches);

  const filtered = leads.filter(l => {
    const q = search.toLowerCase();
    const matchSearch = !q || (l.name||"").toLowerCase().includes(q) || (l.city||"").toLowerCase().includes(q) || (l.category||"").toLowerCase().includes(q) || (l.phone||"").includes(q);
    const matchFilter = filter==="all" || l.intent===filter || l.source===filter;
    return matchSearch && matchFilter;
  });

  const stats = [
    { label:"Total Leads",  value: meta.total || leads.length, icon:"🎯", color:"#00d4aa" },
    { label:"Hot Leads",    value: leads.filter(l=>l.intent==="hot").length, icon:"🔥", color:"#f59e0b" },
    { label:"With Phone",   value: leads.filter(l=>l.phone).length, icon:"📞", color:"#a855f7" },
    { label:"Plan",         value: (meta.plan||"free").toUpperCase(), icon:"⚡", color: isPremium?"#00d4aa":"#6b7280" },
  ];

  const navItems = [
    { label:"Dashboard",  icon:"📊", tab:"leads" },
    { label:"Customer Finder", icon:"🎯", path:"/customer-finder" },
  { label:"Search",     icon:"🔍", path:"/search" },
    { label:"CRM",        icon:"📋", path:"/crm" },
    { label:"Auto Setup", icon:"⚡", path:"/auto-setup" },
    { label:"Settings",   icon:"⚙",  tab:"settings" },
    { label:"Upgrade",    icon:"🚀", path:"/payment" },
  ];

  return (
    <div style={{ minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif", display:"flex" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet" />
      <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}.lcard{animation:fadeIn 0.3s ease both}.lcard:hover{border-color:#ffffff1a!important}`}</style>

      {/* Sidebar */}
      <div style={{ width:220, background:"#080818", borderRight:"1px solid #ffffff08", padding:"28px 14px", display:"flex", flexDirection:"column", position:"fixed", top:0, bottom:0, left:0, zIndex:10 }}>
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:19, fontWeight:900, color:"#00d4aa", marginBottom:36, paddingLeft:8 }}>⚡ LeadBot Pro</div>
        {navItems.map((item,i) => {
          const active = item.tab ? tab===item.tab : false;
          return (
            <div key={i} onClick={() => item.path ? navigate(item.path) : setTab(item.tab)} style={{ display:"flex", alignItems:"center", gap:10, padding:"11px 12px", borderRadius:10, cursor:"pointer", marginBottom:4, background: active?"#00d4aa15":"transparent", color: active?"#00d4aa":"#9ca3af", fontSize:14, fontWeight: active?700:400, transition:"all 0.15s", border: active?"1px solid #00d4aa22":"1px solid transparent" }}
              onMouseEnter={e => { if(!active) e.currentTarget.style.background="#ffffff08"; e.currentTarget.style.color="#fff"; }}
              onMouseLeave={e => { if(!active) e.currentTarget.style.background="transparent"; e.currentTarget.style.color=active?"#00d4aa":"#9ca3af"; }}>
              <span style={{ fontSize:16 }}>{item.icon}</span>{item.label}
            </div>
          );
        })}
        <div style={{ marginTop:"auto", paddingTop:16, borderTop:"1px solid #ffffff08" }}>
          <div style={{ fontSize:11, color:"#6b7280", marginBottom:6, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{email}</div>
          <div style={{ display:"inline-block", background: isPremium?"#00d4aa22":"#ffffff11", color: isPremium?"#00d4aa":"#6b7280", border:"1px solid "+(isPremium?"#00d4aa44":"#ffffff22"), borderRadius:20, padding:"2px 10px", fontSize:11, fontWeight:700, marginBottom:12 }}>{(meta.plan||"free").toUpperCase()}</div>
          <button onClick={logout} style={{ width:"100%", background:"#ff4d4d12", color:"#ff6b6b", border:"1px solid #ff4d4d25", borderRadius:8, padding:"9px 0", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>Logout</button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ marginLeft:220, flex:1, padding:"32px 36px", minHeight:"100vh" }}>

        {/* Header */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:32 }}>
          <div>
            <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:900, margin:0 }}>{tab==="leads" ? "Dashboard" : "Settings"}</h1>
            <p style={{ color:"#6b7280", fontSize:14, margin:"6px 0 0" }}>
              {isPremium ? `Auto-generating leads ${user.lead_frequency === 30 ? "every 30 minutes" : user.lead_frequency === 60 ? "every hour" : user.lead_frequency === 1440 ? "once a day" : `every ${(user.lead_frequency||360)/60} hours`}` : `${searchesLeft}/2 free searches remaining`}
            </p>
          </div>
          <div style={{ display:"flex", gap:10 }}>
            {!isPremium && searchesLeft > 0 && (
              <button onClick={() => navigate("/search")} style={{ background:"#00d4aa22", color:"#00d4aa", border:"1px solid #00d4aa44", borderRadius:10, padding:"10px 18px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>
                🎁 {searchesLeft} Free Search Left
              </button>
            )}
            <button onClick={() => navigate("/search")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:10, padding:"10px 20px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>
              🔍 New Search
            </button>
            <button onClick={() => {
              const isPrem = (meta && meta.plan && meta.plan !== "free");
              if (!isPrem) { alert("CSV export requires a paid plan. Upgrade to download your leads."); window.location.href="/payment"; return; }
              const leads = allLeads || [];
              if (!leads.length) { alert("No leads to export"); return; }
              const fields = ["name","phone","address","source","score","intent","niche","city"];
              const header = fields.join(",");
              const rows = leads.map(l => fields.map(f => '"'+(l[f]||"").toString().replace(/"/g,'""')+'"').join(","));
              const csv = [header,...rows].join("\n");
              const a = document.createElement("a");
              a.href = "data:text/csv;charset=utf-8,"+encodeURIComponent(csv);
              a.download = "leadbot_leads.csv";
              document.body.appendChild(a); a.click(); document.body.removeChild(a);
            }} style={{ background:"#00d4aa22", color:"#00d4aa", border:"1px solid #00d4aa44", borderRadius:10, padding:"10px 16px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>
              ⬇ Export CSV
            </button>
          </div>
        </div>

        {tab === "leads" && (
          <>
            {/* Stats */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:16, marginBottom:28 }}>
              {stats.map((s,i) => (
                <div key={i} style={{ background:"linear-gradient(135deg,#0d0d1f,#0f0f22)", border:"1px solid #ffffff0d", borderRadius:16, padding:"20px 22px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div>
                      <div style={{ color:"#6b7280", fontSize:12, textTransform:"uppercase", letterSpacing:1, marginBottom:10 }}>{s.label}</div>
                      <div style={{ fontFamily:"'Syne',sans-serif", fontSize:30, fontWeight:900, color:s.color }}>{s.value}</div>
                    </div>
                    <span style={{ fontSize:24, opacity:0.6 }}>{s.icon}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Pro banner */}
            {isPremium && (
              <div style={{ background:"linear-gradient(135deg,#00d4aa0d,#00b89408)", border:"1px solid #00d4aa33", borderRadius:16, padding:"16px 20px", marginBottom:24, display:"flex", alignItems:"center", gap:12 }}>
                <div style={{ width:10, height:10, borderRadius:"50%", background:"#00d4aa", boxShadow:"0 0 8px #00d4aa" }} />
                <div>
                  <div style={{ fontWeight:700 }}>Auto Lead Generation Active</div>
                  <div style={{ color:"#9ca3af", fontSize:13 }}>{`Generating fresh leads ${user.lead_frequency === 30 ? "every 30 min" : user.lead_frequency === 60 ? "every 1 hour" : user.lead_frequency === 120 ? "every 2 hours" : user.lead_frequency === 240 ? "every 4 hours" : user.lead_frequency === 1440 ? "once a day" : "every 6 hours"} · Sent to your email`}</div>
                </div>
              </div>
            )}

            {/* Upgrade banner for free */}
            {!isPremium && (
              <div style={{ background:"linear-gradient(135deg,#0d0d1f,#0f0f22)", border:"1px solid #00d4aa33", borderRadius:16, padding:"20px 24px", marginBottom:24, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <div style={{ fontWeight:700, fontSize:16, marginBottom:4 }}>🚀 Unlock Unlimited Leads</div>
                  <div style={{ color:"#9ca3af", fontSize:13 }}>Get 500+ leads/month, auto-generation, CSV export, all phone numbers</div>
                </div>
                <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:10, padding:"11px 24px", cursor:"pointer", fontSize:14, fontWeight:700, fontFamily:"'DM Sans',sans-serif", whiteSpace:"nowrap" }}>Upgrade →</button>
              </div>
            )}

            
        <div onClick={() => navigate("/auto-setup")} style={{ background: isPremium ? "#00d4aa0d" : "#0d0d1f", border:"1px solid " + (isPremium ? "#00d4aa44" : "#ffffff0d"), borderRadius:16, padding:"18px 20px", marginBottom:20, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{ display:"flex", alignItems:"center", gap:14 }}>
            <div style={{ width:44, height:44, borderRadius:12, background: isPremium ? "#00d4aa22" : "#ffffff08", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>⚡</div>
            <div>
              <div style={{ fontWeight:700, fontSize:15, marginBottom:2 }}>Auto Lead Generation</div>
              <div style={{ color:"#9ca3af", fontSize:13 }}>{isPremium ? "Leads emailed to you automatically — click to configure" : "Upgrade to get leads emailed every 30 min automatically"}</div>
            </div>
          </div>
          {isPremium ? <span style={{ color:"#00d4aa", fontSize:18 }}>→</span> : <span style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", borderRadius:8, padding:"5px 12px", fontSize:12, fontWeight:700 }}>Upgrade</span>}
        </div>
        {/* Search & filter */}
            {leads.length > 0 && (
              <div style={{ display:"flex", gap:12, marginBottom:20, flexWrap:"wrap" }}>
                <input placeholder="Search by name, city, category, phone..." value={search} onChange={e => setSearch(e.target.value)} style={{ flex:1, minWidth:220, background:"#0d0d1f", border:"1px solid #ffffff11", borderRadius:10, padding:"11px 16px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none" }} />
                <select value={filter} onChange={e => setFilter(e.target.value)} style={{ background:"#0d0d1f", border:"1px solid #ffffff11", borderRadius:10, padding:"11px 14px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none" }}>
                  <option value="all">All Leads</option>
                  <option value="hot">🔥 Hot</option>
                  <option value="warm">👍 Warm</option>
                  <option value="cold">❄ Cold</option>
                  <option value="Google Maps">Google Maps</option>
                  <option value="JustDial">JustDial</option>
                  <option value="IndiaMart">IndiaMart</option>
                  <option value="Sulekha">Sulekha</option>
                </select>
              </div>
            )}

            {/* Leads list */}
            {loading ? (
              <div style={{ textAlign:"center", padding:80 }}>
                <div style={{ fontSize:48, display:"inline-block", animation:"spin 1s linear infinite" }}>⚡</div>
              </div>
            ) : leads.length === 0 ? (
              <div style={{ background:"#0d0d1f", border:"1px solid #ffffff0d", borderRadius:20, padding:72, textAlign:"center" }}>
                <div style={{ fontSize:52, marginBottom:16 }}>🎯</div>
                <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, marginBottom:10 }}>No leads yet</h3>
                <p style={{ color:"#9ca3af", marginBottom:28 }}>Use the search to find real businesses with phone numbers.</p>
                <button onClick={() => navigate("/search")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:12, padding:"13px 32px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:15, cursor:"pointer" }}>
                  🔍 Search Leads Now
                </button>
              </div>
            ) : (
              <div>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
                  <span style={{ color:"#6b7280", fontSize:13 }}>{filtered.length} leads {search||filter!=="all"?"(filtered)":""}</span>
                  <div style={{ display:"flex", gap:8 }}>
                    {["hot","warm","cold"].map(t => (
                      <span key={t} style={{ background: intentStyle[t].bg, color: intentStyle[t].color, border:"1px solid "+intentStyle[t].border, borderRadius:8, padding:"3px 10px", fontSize:12, fontWeight:700 }}>
                        {t==="hot"?"🔥":t==="warm"?"👍":"❄"} {leads.filter(l=>l.intent===t).length}
                      </span>
                    ))}
                  </div>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  {filtered.map((lead,i) => {
                    const ist = intentStyle[lead.intent] || intentStyle.warm;
                    const sc  = SRC_COLOR[lead.source] || "#9ca3af";
                    return (
                      <div key={i} className="lcard" style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #ffffff08", borderRadius:16, padding:"16px 20px", display:"grid", gridTemplateColumns:"52px 1fr auto", gap:16, alignItems:"start", transition:"all 0.2s", animationDelay:`${Math.min(i,20)*0.03}s` }}>
                        <div style={{ width:52, height:52, borderRadius:13, background: scoreColor(lead.score||0)+"15", border:"2px solid "+scoreColor(lead.score||0)+"55", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
                          <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:900, color: scoreColor(lead.score||0), fontSize:19, lineHeight:1 }}>{lead.score||"?"}</div>
                          <div style={{ fontSize:8, color:"#6b7280", marginTop:2 }}>SCORE</div>
                        </div>
                        <div>
                          <div style={{ fontWeight:700, fontSize:15, marginBottom:5 }}>{lead.name}</div>
                          <div style={{ display:"flex", gap:14, fontSize:13, flexWrap:"wrap", marginBottom:5 }}>
                            {lead.phone   && <span style={{ color:"#00d4aa", fontWeight:600 }}>📞 {lead.phone}</span>}
                            {lead.address && <span style={{ color:"#9ca3af" }}>📍 {lead.address}</span>}
                          </div>
                          <div style={{ display:"flex", gap:10, fontSize:12, flexWrap:"wrap" }}>
                            {lead.rating > 0 && <span style={{ color:"#f59e0b" }}>⭐ {lead.rating} <span style={{ color:"#6b7280" }}>({(lead.reviews||0).toLocaleString()})</span></span>}
                            {lead.website  && <a href={lead.website} target="_blank" rel="noreferrer" style={{ color:"#60a5fa", textDecoration:"none" }}>🌐 Website</a>}
                            {lead.category && <span style={{ color:"#6b7280" }}>📂 {lead.category}</span>}
                          </div>
                        </div>
                        <div style={{ display:"flex", flexDirection:"column", gap:5, alignItems:"flex-end" }}>
                          <span style={{ background: sc+"22", color: sc, border:"1px solid "+sc+"44", borderRadius:8, padding:"3px 10px", fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>{lead.source}</span>
                          <span style={{ background: ist.bg, color: ist.color, border:"1px solid "+ist.border, borderRadius:8, padding:"3px 10px", fontSize:11, fontWeight:700, textTransform:"uppercase" }}>{lead.intent||"warm"}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {meta.locked > 0 && (
                  <div style={{ background:"#0d0d1f", border:"2px solid #00d4aa22", borderRadius:16, padding:28, marginTop:16, textAlign:"center" }}>
                    <div style={{ fontSize:28, marginBottom:8 }}>🔒</div>
                    <div style={{ fontFamily:"'Syne',sans-serif", fontSize:18, fontWeight:900, marginBottom:6 }}>{meta.locked} leads locked</div>
                    <p style={{ color:"#9ca3af", fontSize:14, marginBottom:16 }}>Upgrade to unlock all leads with phone numbers.</p>
                    <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:10, padding:"11px 26px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:14, cursor:"pointer" }}>Upgrade Now</button>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {tab === "settings" && (
          <div style={{ maxWidth:520 }}>
            <div style={{ background:"#0d0d1f", border:"1px solid #ffffff0d", borderRadius:20, padding:32, marginBottom:20 }}>
              <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:18, fontWeight:900, marginBottom:20 }}>Account</h3>
              <div style={{ marginBottom:16 }}>
                <div style={{ color:"#6b7280", fontSize:12, marginBottom:4 }}>EMAIL</div>
                <div style={{ color:"#fff", fontSize:15 }}>{email}</div>
              </div>
              <div style={{ marginBottom:20 }}>
                <div style={{ color:"#6b7280", fontSize:12, marginBottom:4 }}>PLAN</div>
                <div style={{ color: isPremium?"#00d4aa":"#6b7280", fontSize:15, fontWeight:700 }}>{(meta.plan||"free").toUpperCase()}</div>
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <button onClick={() => navigate("/forgot-password")} style={{ background:"#ffffff0d", color:"#9ca3af", border:"1px solid #ffffff11", borderRadius:10, padding:"10px 18px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>Change Password</button>
                {!isPremium && <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:10, padding:"10px 18px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>Upgrade Plan</button>}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
// Sun Apr 19 12:42:16 IST 2026
